"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheGraphError = void 0;
const sdks_perp_1 = require("@synfutures/sdks-perp");
class TheGraphError extends sdks_perp_1.SynfError {
    constructor(message) {
        super(message);
        this.name = 'TheGraph';
    }
}
exports.TheGraphError = TheGraphError;
